module.exports = __webpack_public_path__ + "static/media/Trace3_Logo.3c7c8161.png";